export default {
  header: {
    title: "Mes Projets",
    subtitle: "Gérez vos projets d'infrastructure cloud",
    newProject: "Nouveau Projet"
  },
  search: {
    placeholder: "Rechercher un projet..."
  },
  filters: {
    allProviders: "Tous les providers",
    allTags: "Tous les tags",
    showArchived: "Afficher les projets archivés",
    sortByDate: "Trier par date",
    sortByName: "Trier par nom",
    sortByArchitectures: "Trier par architectures",
    ascending: "Croissant",
    descending: "Décroissant"
  },
  providers: {
    azure: "Azure",
    aws: "AWS",
    gcp: "GCP",
    all: "Tous"
  },
  selection: {
    selected: "projet sélectionné",
    selected_plural: "projets sélectionnés",
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner",
    deselectTitle: "Tout désélectionner"
  },
  buttons: {
    dashboard: "Tableau de bord",
    import: "Importer",
    export: "Exporter",
    exportSelected: "Exporter",
    exportTitle: "Exporter les projets sélectionnés",
    selectProjectsToExport: "Sélectionnez des projets à exporter"
  },
  views: {
    grid: "Vue en grille",
    list: "Vue en liste"
  },
  empty: {
    noProjects: "Aucun projet",
    noProjectsDescription: "Créez votre premier projet pour commencer",
    createProject: "Créer un projet",
    noResults: "Aucun projet trouvé",
    noResultsDescription: "Essayez de modifier vos critères de recherche"
  },
  card: {
    architectures: "architectures",
    archived: "Archivé"
  },
  table: {
    project: "Projet",
    provider: "Provider",
    architectures: "Architectures",
    lastModified: "Dernière modification",
    createdBy: "Créé par",
    actions: "Actions"
  },
  actions: {
    edit: "Modifier",
    duplicate: "Dupliquer",
    archive: "Archiver",
    unarchive: "Désarchiver",
    delete: "Supprimer"
  },
  dates: {
    today: "Aujourd'hui",
    yesterday: "Hier",
    daysAgo: "Il y a {{count}} jours"
  },
  modal: {
    createTitle: "Nouveau Projet",
    editTitle: "Modifier le projet",
    nameLabel: "Nom du projet",
    nameRequired: "Nom du projet *",
    namePlaceholder: "Ex: Infrastructure Production",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Décrivez votre projet...",
    providerLabel: "Fournisseur Cloud",
    tagsLabel: "Tags",
    tagsPlaceholder: "Ajouter un tag...",
    providerAzure: "Microsoft Azure",
    providerAWS: "Amazon Web Services",
    providerGCP: "Google Cloud Platform",
    cancel: "Annuler",
    create: "Créer",
    save: "Enregistrer",
    nameRequiredError: "Le nom du projet est requis"
  },
  messages: {
    deleteTitle: "Supprimer le projet",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce projet ?",
    confirmDeleteProject: "Êtes-vous sûr de vouloir supprimer le projet \"{{name}}\" ? Cette action est irréversible.",
    createSuccess: "✅ Projet créé avec succès en base de données !",
    updateSuccess: "✅ Projet mis à jour avec succès !",
    deleteSuccess: "✅ Projet supprimé avec succès !",
    archiveSuccess: "✅ Statut d'archivage mis à jour avec succès !",
    createError: "❌ Erreur: {{error}}\n\nVérifiez que vous êtes bien connecté.",
    updateError: "❌ Erreur lors de la mise à jour: {{error}}",
    deleteError: "❌ Erreur lors de la suppression: {{error}}",
    archiveError: "❌ Erreur lors de l'archivage: {{error}}",
    exportSelectAtLeastOne: "Veuillez sélectionner au moins un projet à exporter.",
    exportSuccess: "✅ {{count}} projet(s) exporté(s) avec succès !",
    exportError: "❌ Erreur lors de l'export: {{error}}",
    exportProjectError: "Erreur lors de l'export du projet \"{{name}}\". Continuant avec les autres projets...",
    importSuccess: "✅ {{successCount}} projet(s) importé(s) avec succès !",
    importSuccessWithErrors: "✅ {{successCount}} projet(s) importé(s) avec succès !\n⚠️ {{errorCount}} projet(s) en erreur.",
    importNoProjects: "❌ Aucun projet n'a pu être importé.",
    importError: "❌ Erreur lors de l'importation: {{error}}",
    importInvalidFile: "❌ Le fichier \"{{filename}}\" n'est pas un export de projet GenIaC valide.",
    importInvalidFormat: "❌ Ce fichier n'est pas un export de projet GenIaC. Veuillez importer un fichier de projet valide.",
    importUnsupportedFormat: "❌ Format de fichier non supporté. Veuillez importer un fichier .json ou .zip",
    importNoValidProjects: "❌ Aucun projet valide trouvé dans le fichier."
  },
  console: {
    loadingProjects: "📡 Chargement des projets depuis l'API...",
    projectsLoaded: "✅ Projets chargés:",
    mappedProjects: "📊 Projets mappés:",
    loadError: "❌ Erreur lors du chargement des projets:",
    fallbackLocalStorage: "⚠️ Fallback vers localStorage",
    noProjects: "⚠️ Aucun projet disponible",
    creatingProject: "📡 Création du projet via API...",
    projectCreated: "✅ Projet créé avec succès:",
    createError: "❌ Erreur lors de la création du projet:",
    updatingProject: "📡 Mise à jour du projet via API...",
    projectUpdated: "✅ Projet mis à jour avec succès",
    updateError: "❌ Erreur lors de la mise à jour:",
    deletingProject: "📡 Suppression du projet via API...",
    projectDeleted: "✅ Projet supprimé avec succès",
    deleteError: "❌ Erreur lors de la suppression:",
    archivingProject: "📡 Archivage du projet via API...",
    projectArchived: "✅ Projet archivé avec succès",
    archiveError: "❌ Erreur lors de l'archivage:",
    exportingProjects: "📦 Export de {{count}} projet(s) avec leurs architectures...",
    projectArchitectures: "✅ Projet \"{{name}}\": {{count}} architecture(s) trouvée(s)",
    fetchingArchDetails: "📦 Récupération des détails complets de l'architecture \"{{name}}\"...",
    archDetailsError: "❌ Erreur lors de la récupération de l'architecture {{name}}:",
    completeArchitectures: "✅ Projet \"{{name}}\": {{count}} architecture(s) complète(s) chargée(s)",
    exportProjectError: "❌ Erreur lors de l'export du projet {{name}}:",
    exportError: "❌ Erreur lors de l'export:",
    importingProjects: "📦 Import de {{count}} projet(s)...",
    projectCreatedWithId: "✅ Projet \"{{name}}\" créé avec ID: {{id}}",
    architecturesImported: "✅ {{count}} architecture(s) importée(s)",
    importArchError: "❌ Erreur lors de l'import de l'architecture \"{{name}}\":",
    importProjectError: "❌ Erreur lors de l'import du projet:",
    importError: "❌ Erreur lors de l'importation:"
  }
};
